import React from 'react';
import { Route, BrowserRouter } from 'react-router-dom';


import Home from './Components/Home';
import MedicalHome from './Components/MedicalHome';
import SearchInModule from './Components/Triage/SearchInModule';


// Authentication Components
import StaffLogin from './Components/Auth/StaffLogin'
import RegisterStaff from './Components/Auth/RegisterStaff';
import ForgotPasswordEmail from './Components/Auth/ForgotPasswordEmail';
import UpdatePassword from './Components/Auth/UpdatePassword';

// Administrators Components
import AddProcedureCost from './Components/Adminstrators_Portal/AddProcedureCost';
import cms from './Components/Adminstrators_Portal/cms';

// Reception and Billing Components
import ReceptionDashboard from './Components/Reception&Billing/ReceptionDashboard';
import NewPatientDetails from './Components/Reception&Billing/NewPatientDetails';
import NextOfKin from './Components/Reception&Billing/NextOfKin'
import PatientDetails from './Components/Reception&Billing/PatientDetails'
import SearchPatient from './Components/Reception&Billing/SearchPatient'
import Billing from './Components/Reception&Billing/Billing'
import ConfirmPatient from './Components/Reception&Billing/ConfirmPatient';
import PendingPayments from './Components/Reception&Billing/PendingPayments';



// Triage components
import AntenatalHistory from './Components/Triage/AntenatalHistory'
import DiagnosisStudy from './Components/Triage/DiagnosisStudy'
import GeneralObservations from './Components/Triage/GeneralObservations'
import MenstrualHistory from './Components/Triage/MenstrualHistory'
import PhysicalExamination from './Components/Triage/PhysicalExamination'
import PreplanAnalysisExecuted from './Components/Triage/PreplanAnalysisExecuted'
import PreviousObstetricsHistory from './Components/Triage/PreviousObstetricsHistory'
import PreviousPregnantComplication from './Components/Triage/PreviousPregnantComplication'
import PriorObOrGynInfections from './Components/Triage/PriorObOrGynInfections'
import SexualHistory from './Components/Triage/SexualHistory'
import TestsToBeDoneInLab from './Components/Triage/TestsToBeDoneInLab'
import UtilizationOfDrugs from './Components/Triage/UtilizationOfDrugs'
import TriageDashboard from './Components/Triage/TriageDashboard'
import PreviousObstetricHistoryPregnancy from './Components/Triage/PreviousObstetricHistoryPregnancy'
import ObSound from './Components/Triage/ObSound'
import MedicalOrders from './Components/Triage/MedicalOrders'
import Treatment from './Components/Triage/Treatment'
import HistoryTaking from './Components/Triage/HistoryTaking'
import PhysicalExaminationInspection from './Components/Triage/PhysicalExaminationInspection'
import PhysicalExaminationPelvic from './Components/Triage/PhysicalExaminationPelvic'
import PhysicalExaminationInduction from './Components/Triage/PhysicalExaminationInduction'
import PreviousPregnacy from './Components/Triage/PreviousPregnacy'
import InitDashboard from './Components/Triage/InitDashboard'
import AdmissionTriage from './Components/Triage/AdmissionTriage'
import PreviousGynecologyAbdominal from './Components/Triage/PreviousGynecologyAbdominal'
import DoctorGeneralObservation from './Components/Triage/DoctorGeneralObservation'
import AllData from './Components/Triage/AllData'
import ChiefComplaint from './Components/Triage/ChiefComplaint'
import AllTreatment from './Components/Triage/AllTreatment'
import SingleTreatment from './Components/Triage/SingleTreatment'
import ExternalTestsSelect from './Components/InterModularComponents/ExternalTestsSelect'



///gynecology wards

import GynecologyDashboard from './Components/Gynecology/Dashboard'
import GAntenatalHistory from './Components/Gynecology/AntenatalHistory'
import GDiagnosisStudy from './Components/Gynecology/DiagnosisStudy'
import GMenstrualHistory from './Components/Gynecology/MenstrualHistory'
import GObSound from './Components/Gynecology/ObSound'
import GPhysicalExamination from './Components/Gynecology/PhysicalExamination'
import GPrePlanAnalysis from './Components/Gynecology/PrePlanAnalysis'
import GPreviousObstetricsHistory from './Components/Gynecology/PreviousObstetricHistory'
import GPreviousPregnantComplication from './Components/Gynecology/PreviousPregnancyComplications'
import GSearchInModule from './Components/Gynecology/SearchInModule'
import GUtilizationOfDrugs from './Components/Gynecology/UtilizationOfDrugs'
import GHistoryTaking from './Components/Gynecology/HistoryTaking'
import PreviousPregnacyObHistory from './Components/Gynecology/PreviousPregnacyObHistory'
import GPreviousPregnancyComplications from './Components/Gynecology/PreviousPregnancyComplications'
// import GPreviousPregnacy from './Components/Gynecology/PreviousPregancy'
import GSexualHistory from './Components/Gynecology/SexualHistory'
import GPriorObGynInfection from './Components/Gynecology/PriorObGynInfection'
import MedicalDisorders from './Components/Gynecology/MedicalDisorders'
import Abdominal from './Components/Gynecology/Abdominal'
import GPhysicalExaminationInspection from './Components/Gynecology/PhysicalExaminationInspection'
import GPhysicalExaminationPelvic from './Components/Gynecology/PhysicalExaminationPelvic';
import GAllData from './Components/Gynecology/AllData';


///gynecology2 wards

// import GynecologyDashboard from './Components/Gynecology/Dashboard'
import G2AntenatalHistory from './Components/Gynecology2/AntenatalHistory'
import G2DiagnosisStudy from './Components/Gynecology2/DiagnosisStudy'
import G2MenstrualHistory from './Components/Gynecology2/MenstrualHistory'
import G2ObSound from './Components/Gynecology2/ObSound'
import G2PhysicalExamination from './Components/Gynecology2/PhysicalExamination'
import G2PrePlanAnalysis from './Components/Gynecology2/PrePlanAnalysis'
import G2PreviousObstetricsHistory from './Components/Gynecology2/PreviousObstetricHistory'
import G2PreviousPregnantComplication from './Components/Gynecology2/PreviousPregnancyComplications'
import G2SearchInModule from './Components/Gynecology2/SearchInModule'
import G2UtilizationOfDrugs from './Components/Gynecology2/UtilizationOfDrugs'
import G2HistoryTaking from './Components/Gynecology2/HistoryTaking'
import G2PreviousPregnacyObHistory from './Components/Gynecology2/PreviousPregnacyObHistory'
import G2PreviousPregnancyComplications from './Components/Gynecology2/PreviousPregnancyComplications'
// import G2PreviousPregnacy from './Components/Gynecology2/PreviousPregancy'
import G2SexualHistory from './Components/Gynecology2/SexualHistory'
import G2PriorObGynInfection from './Components/Gynecology2/PriorObGynInfection'
import MedicalDisorders2 from './Components/Gynecology2/MedicalDisorders'
import Abdominal2 from './Components/Gynecology2/Abdominal'
import G2PhysicalExaminationInspection from './Components/Gynecology2/PhysicalExaminationInspection'
import G2PhysicalExaminationPelvic from './Components/Gynecology2/PhysicalExaminationPelvic'




//labour routes
import Partograph from './Components/Labour/Partograph'
import LSearchInModule from './Components/Labour/SearchInModule'

import ConfirmStaffMember from './Components/Adminstrators_Portal/ConfirmStaffMember'
import RegisterChief from './Components/Adminstrators_Portal/RegisterChief'
import AdminDashboard from './Components/Adminstrators_Portal/Dashboard';
import AllActivePatients from './Components/Adminstrators_Portal/AllActivePatients';
import AllStaffMembers from './Components/Adminstrators_Portal/AllStaffMembers';
import PatientAllData from './Components/Adminstrators_Portal/PatientAllData';
import EditDetails from './Components/Adminstrators_Portal/EditDetails';


// new born routes
import NewbornUnitDashboard from './Components/NewbornUnit/NewbornDashboard';
import NewbornDemographicData from './Components/NewbornUnit/NewbornDemographicData';
import TreatmentCounselling from './Components/NewbornUnit/TreatmentCounselling';
import NewbornPhysicalExamination from './Components/NewbornUnit/NewbornPhysicalExamination';
import NewbornProcedures from './Components/NewbornUnit/NewbornProcedures';
import NewbornReferral from './Components/NewbornUnit/NewbornReferral';
import NBSearchInModule from './Components/NewbornUnit/SearchInModule';
import NewbornWardRound from './Components/NewbornUnit/WardRound';




// Delivery routes
import DSearchInModule from './Components/Delivery/SearchInModule';
import ImmediateAssistanceOfTheNewborn from './Components/Delivery/ImmediateAssistanceOfTheNewborn';
import ImmediateObservationOfTheMother from './Components/Delivery/ImmediateObservationOfTheMother';
import Delivery from './Components/Delivery/Delivery';
import PlacentaDelivery from './Components/Delivery/PlacentaDelivery';
import ApgarScore from './Components/Delivery/ApgarScore';




import OSearchInModule from './Components/Theatre/SearchInModule';
import OImmediateObservationOfTheMother from './Components/Theatre/ImmediateObservationOfTheMother';
import PostOperativeOrders from './Components/Theatre/PostOperativeOrders';
import ProcedureReports from './Components/Theatre/ProcedureReports';
import OperatingDelivery from './Components/Theatre/OperatingDelivery';
import PostOpFInal from './Components/Theatre/PostOpFInal';
import PostOpObservationScare1 from './Components/Theatre/PostOpObservationScare1';
import PostOpObservationScare2 from './Components/Theatre/PostOpObservationScare2';
import PostOpPreliminary from './Components/Theatre/PostOpPreliminary';
import Postoprecoveryroomhandover from './Components/Theatre/Postoprecoveryroomhandover';
import IntraOperativeDestination from './Components/Theatre/IntraOperativeDestination';
import IntraOperativeElectrosurgicalUnitAnaesthesia from './Components/Theatre/IntraOperativeElectrosurgicalUnitAnaesthesia';
import IntraOperativeGeneralTiming from './Components/Theatre/IntraOperativeGeneralTiming';
import IntraOperativeMedicationsgiven from './Components/Theatre/IntraOperativeMedicationsgiven';
import IntraOperativePositioningCatheter from './Components/Theatre/IntraOperativePositioningCatheter';
import IntraOperativeSpecimensXraysTaken from './Components/Theatre/IntraOperativeSpecimensXraysTaken';
import IntraOperativeSurgicalProsthesis from './Components/Theatre/IntraOperativeSurgicalProsthesis';
import IntraOperativeSurgicalTeam from './Components/Theatre/IntraOperativeSurgicalTeam';
import IntraOperativeSwabInstruments from './Components/Theatre/IntraOperativeSwabInstruments';
import IntraOperativeTheatreEntry from './Components/Theatre/IntraOperativeTheatreEntry';
import IntraOperativeTourniquetDrain from './Components/Theatre/IntraOperativeTourniquetDrain';
import IntraOperativeWoundTransfusion from './Components/Theatre/IntraOperativeWoundTransfusion';
import NewSurgery from './Components/Theatre/NewSurgery';





import SendToModule from './Components/InterModularComponents/SendToModule';
import ExternalLabResults from './Components/InterModularComponents/ExternalLabResults';
import DischargeForm from './Components/InterModularComponents/DischargeForm';
import WardRound from './Components/InterModularComponents/WardRound';
import CreateBill from './Components/InterModularComponents/CreateBill';




import GuestHome from './Components/GuestSite/GuestHome';
import Location from './Components/GuestSite/Location';
import ContactUs from './Components/GuestSite//ContactUs';


import LBSearchInModule from './Components/LabModule/SearchInModule';
import LabForm from './Components/LabModule/LabForm';
import BloodLiverLipid from './Components/LabModule/BloodLiverLipid';
import MalariaPregnacyUrinalysisStoolSediment from './Components/LabModule/MalariaPregnancyUrinalysisStoolSediment';
import UricThyroidCoagulationElisa from './Components/LabModule/UricThyroidCoagulationElisa';
import Serology from './Components/LabModule/Serology';
import TestsRequested from './Components/LabModule/TestsRequested';




//POst Natal


import MonitoringForm from './Components/PostNatalModule/MonitoringForm';
import ObservationandManagement from './Components/PostNatalModule/ObservationandManagement';
import PNSearchInModule from './Components/PostNatalModule/SearchInModule';
// import Dashboard from './containers/Dashboard/Dashboard';
// import { history } from './history';

const Routes = () => {
	return (
		<BrowserRouter>
			{/* Route Definitions */}

			{/* guest routes */}
			<Route exact path="/" component={StaffLogin} />
			<Route exact path="/home" component={Home} />
			<Route exact path="/medical/home" component={MedicalHome} />
			<Route exact path="/search/in/module" component={SearchInModule} />
			<Route exact path="/administrator/cms" component={cms} />

			{/* general routes */}
			{/* <Route exact path="/home" component={SingleDevice}/> */}
			{/* <Route exact path="/my/devices" component={MyDevices}/> */}

			{/* auth routes */}
			<Route exact path="/register/staff" component={RegisterStaff} />
			<Route exact path="/login" component={StaffLogin} />
			<Route exact path="/forgot/password" component={ForgotPasswordEmail} />
			<Route exact path="/update/password" component={UpdatePassword} />

			{/* admin routes */}
			<Route exact path='/admin/dashboard' component={AdminDashboard} />
			<Route exact path='/all/active/patients' component={AllActivePatients} />
			<Route exact path='/add/procedure/cost' component={AddProcedureCost} />
			<Route exact path='/confirm/staff/member' component={ConfirmStaffMember} />
			<Route exact path='/register/chief' component={RegisterChief} />
			<Route exact path='/all/staff/members' component={AllStaffMembers} />
			<Route exact path='/patient/all/data' component={PatientAllData} />
			<Route exact path='/edit/current/details' component={EditDetails} />
			{/* <Route exact path='/add/new/member' component={AddNewMember} />
				<Route exact path='/add/new/team' component={MakeNewTeam} />
				<Route exact path='/make/team/lead' component={MakeTeamLead} /> */}

			{/* reception & billing routes */}
			<Route exact path='/reception/dashboard' component={ReceptionDashboard} />
			<Route exact path='/input/patient/details' component={NewPatientDetails} />
			<Route exact path='/input/next/kin' component={NextOfKin} />
			<Route exact path='/search/patient' component={SearchPatient} />
			<Route exact path='/patient/details' component={PatientDetails} />
			<Route exact path='/get/bill/ticket' component={Billing} />
			<Route exact path='/confirm/patient' component={ConfirmPatient} />
			<Route exact path='/pending/payments' component={PendingPayments} />

			{/* triage routes */}
			<Route exact path='/antenatal/history' component={AntenatalHistory} />
			<Route exact path='/diagnosis/study' component={DiagnosisStudy} />
			<Route exact path='/general/observations' component={GeneralObservations} />
			<Route exact path='/menstrual/history' component={MenstrualHistory} />
			<Route exact path='/physical/examination' component={PhysicalExamination} />
			<Route exact path='/preplan/analysis' component={PreplanAnalysisExecuted} />
			<Route exact path='/prior/ob/or/gyn/infections' component={PriorObOrGynInfections} />
			<Route exact path='/dashboard' component={TriageDashboard} />
			<Route exact path='/tests/to/be/done' component={TestsToBeDoneInLab} />
			<Route exact path='/sexual/history' component={SexualHistory} />
			<Route exact path='/tests/to/be/done/in/lab' component={TestsToBeDoneInLab} />
			<Route exact path='/utilization/of/drugs' component={UtilizationOfDrugs} />
			<Route exact path='/previous/obstetrics/history' component={PreviousObstetricsHistory} />
			<Route exact path='/previous/pregnancy/complication' component={PreviousPregnantComplication} />
			<Route exact path='/previous/obstetrics/pregnancy/history' component={PreviousObstetricHistoryPregnancy} />
			<Route exact path='/ob/sound' component={ObSound} />
			<Route exact path='/medical/disorders' component={MedicalOrders} />
			<Route exact path='/treatment' component={Treatment} />
			<Route exact path='/history/taking' component={HistoryTaking} />
			<Route exact path='/physical/examination/induction' component={PhysicalExaminationInduction} />
			<Route exact path='/physical/examination/inspection' component={PhysicalExaminationInspection} />
			<Route exact path='/physical/examination/pelvic' component={PhysicalExaminationPelvic} />
			<Route exact path='/previous/pregancy' component={PreviousPregnacy} />
			<Route exact path='/triage/init/dashboard' component={InitDashboard} />
			<Route exact path='/triage/admission/triage' component={AdmissionTriage} />
			<Route exact path='/previous/abdominal' component={PreviousGynecologyAbdominal} />
			<Route exact path='/doctor/general/observation' component={DoctorGeneralObservation} />
			<Route exact path='/chief/complaint' component={ChiefComplaint} />
			<Route exact path='/all/data' component={AllData} />
			<Route exact path='/all/treatment' component={AllTreatment} />
			<Route exact path='/single/treatment/' component={SingleTreatment} />
			<Route exact path='/external/lab/test/input' component={ExternalTestsSelect} />


			{/* gynecology routes */}
			<Route exact path='/gynecology/dashboard' component={GynecologyDashboard} />
			<Route exact path='/gynecology/antenatal/history' component={GAntenatalHistory} />
			{/* <Route exact path='/gynecology/history/taking' component={} /> */}
			<Route exact path='/gynecology/diagnosis/study' component={GDiagnosisStudy} />
			<Route exact path='/gynecology/menstrual/history' component={GMenstrualHistory} />
			<Route exact path='/gynecology/ob/sound' component={GObSound} />
			<Route exact path='/gynecology/physical/examination' component={GPhysicalExamination} />
			<Route exact path='/gynecology/preplan/analysis' component={GPrePlanAnalysis} />
			<Route exact path='/gynecology/previous/obstetricsHistory' component={GPreviousObstetricsHistory} />
			<Route exact path='/gynecology/previous/pregnant/complication' component={GPreviousPregnantComplication} />
			<Route exact path='/gynecology/search/in/module' component={GSearchInModule} />
			<Route exact path='/gynecology/utilization/of/drugs' component={GUtilizationOfDrugs} />
			<Route exact path='/gynecology/history/taking' component={GHistoryTaking} />
			<Route exact path='/gynecology/previous/pregancy' component={PreviousPregnacyObHistory} />
			<Route exact path='/gynecology/previous/pregancy/complication' component={GPreviousPregnancyComplications} />
			<Route exact path='/gynecology/sexual/history' component={GSexualHistory} />
			<Route exact path='/gynecology/prior/gyn/infection' component={GPriorObGynInfection} />
			<Route exact path='/gynecology/medical/disorders' component={MedicalDisorders} />
			<Route exact path='/gynecology/physical/examination/inspection' component={GPhysicalExaminationInspection} />
			<Route exact path='/gynecology/physical/examination/pelvic' component={GPhysicalExaminationPelvic} />
			<Route exact path='/all/modules/data' component={GAllData} />
			<Route exact path='/gynecology/previous/abdominal' component={Abdominal} />

			{/* gynecology 2routes */}
			{/* <Route exact path='/gynecology2/dashboard' component={GynecologyDashboard} /> */}
			<Route exact path='/gynecology2/antenatal/history' component={G2AntenatalHistory} />
			{/* <Route exact path='/gynecology2/history/taking' component={} /> */}
			<Route exact path='/gynecology2/diagnosis/study' component={G2DiagnosisStudy} />
			<Route exact path='/gynecology2/menstrual/history' component={G2MenstrualHistory} />
			<Route exact path='/gynecology2/ob/sound' component={G2ObSound} />
			<Route exact path='/gynecology2/physical/examination' component={G2PhysicalExamination} />
			<Route exact path='/gynecology2/preplan/analysis' component={G2PrePlanAnalysis} />
			<Route exact path='/gynecology2/previous/obstetricsHistory' component={G2PreviousObstetricsHistory} />
			<Route exact path='/gynecology2/previous/pregnant/complication' component={G2PreviousPregnantComplication} />
			<Route exact path='/gynecology2/search/in/module' component={G2SearchInModule} />
			<Route exact path='/gynecology2/utilization/of/drugs' component={G2UtilizationOfDrugs} />
			<Route exact path='/gynecology2/history/taking' component={G2HistoryTaking} />
			<Route exact path='/gynecology2/previous/pregancy' component={G2PreviousPregnacyObHistory} />
			<Route exact path='/gynecology2/previous/pregancy/complication' component={G2PreviousPregnancyComplications} />
			<Route exact path='/gynecology2/sexual/history' component={G2SexualHistory} />
			<Route exact path='/gynecology2/prior/gyn/infection' component={G2PriorObGynInfection} />
			<Route exact path='/gynecology2/medical/disorders' component={MedicalDisorders2} />
			<Route exact path='/gynecology2/physical/examination/inspection' component={G2PhysicalExaminationInspection} />
			<Route exact path='/gynecology2/physical/examination/pelvic' component={G2PhysicalExaminationPelvic} />
			<Route exact path='/gynecology2/previous/abdominal' component={Abdominal2} />

			{/* labour routes */}
			<Route exact path='/labour/partograph' component={Partograph} />
			<Route exact path='/labour/search/in/module' component={LSearchInModule} />

			{/* delivery routes */}
			<Route exact path='/delivery/general' component={Delivery} />
			<Route exact path='/delivery/assistance/new/born' component={ImmediateAssistanceOfTheNewborn} />
			<Route exact path='/delivery/immediate/observation/mother' component={ImmediateObservationOfTheMother} />
			<Route exact path='/delivery/search/in/module' component={DSearchInModule} />
			<Route exact path='/delivery/placenta/delivery' component={PlacentaDelivery} />
			<Route exact path='/delivery/apgar/score' component={ApgarScore} />


			{/* theatre routes*/}
			<Route exact path='/theatre/post/op/final' component={PostOpFInal} />
			<Route exact path='/theatre/post/op/observations/care1' component={PostOpObservationScare1} />
			<Route exact path='/theatre/post/op/observations/care2' component={PostOpObservationScare2} />
			<Route exact path='/theatre/post/prelimanry' component={PostOpPreliminary} />
			<Route exact path='/theatre/recovery/room/handover' component={Postoprecoveryroomhandover} />
			<Route exact path='/theatre/search/in/module' component={OSearchInModule} />
			<Route exact path='/theatre/observation/of/mother' component={OImmediateObservationOfTheMother} />
			<Route exact path='/theatre/post/operative/orders' component={PostOperativeOrders} />
			<Route exact path='/theatre/procedure/reports' component={ProcedureReports} />
			<Route exact path='/theatre/operating/delivery' component={OperatingDelivery} />
			<Route exact path='/theatre/new/surgery' component={NewSurgery} />


			<Route exact path='/theatre/intra/op/destination' component={IntraOperativeDestination} />
			<Route exact path='/theatre/intra/op/electr/surg/unit/anaesthesia' component={IntraOperativeElectrosurgicalUnitAnaesthesia} />
			<Route exact path='/theatre/intra/op/general/timing' component={IntraOperativeGeneralTiming} />
			<Route exact path='/theatre/intra/op/medic/given' component={IntraOperativeMedicationsgiven} />
			<Route exact path='/theatre/intra/op/positioningcatheter' component={IntraOperativePositioningCatheter} />
			<Route exact path='/theatre/intra/op/specimen/xray/taken' component={IntraOperativeSpecimensXraysTaken} />
			<Route exact path='/theatre/intra/op/surgical/prothesis' component={IntraOperativeSurgicalProsthesis} />
			<Route exact path='/theatre/intra/op/surgical/team' component={IntraOperativeSurgicalTeam} />
			<Route exact path='/theatre/intra/op/swab/instruments' component={IntraOperativeSwabInstruments} />
			<Route exact path='/theatre/intra/op/theatre/entry' component={IntraOperativeTheatreEntry} />
			<Route exact path='/theatre/intra/op/tournique/drain' component={IntraOperativeTourniquetDrain} />
			<Route exact path='/theatre/intra/op/wound/tranfusion' component={IntraOperativeWoundTransfusion} />



			{/* Newborn Routes */}
			<Route exact path='/newbornunit/dashboard' component={NewbornUnitDashboard} />
			<Route exact path='/newbornunit/newborn/demographic/data' component={NewbornDemographicData} />
			<Route exact path='/newbornunit/treatment/counselling' component={TreatmentCounselling} />
			<Route exact path='/newbornunit/physical/examination' component={NewbornPhysicalExamination} />
			<Route exact path='/newbornunit/procedures' component={NewbornProcedures} />
			<Route exact path='/newbornunit/referral' component={NewbornReferral} />
			<Route exact path='/newbornunit/ward/round' component={NewbornWardRound} />
			<Route exact path='/newbornunit/search/in/module' component={NBSearchInModule} />


			<Route exact path='/discharge/form' component={DischargeForm} />
			<Route exact path='/ward/round' component={WardRound} />
			<Route exact path='/create/bill' component={CreateBill} />


			<Route exact path='/lab/search/in/module' component={LBSearchInModule} />
			<Route exact path='/labform' component={LabForm} />



			{/* post-natal module */}

			<Route exact path='/post/natal/observation/management' component={ObservationandManagement} />
			<Route exact path='/post/natal/search/in/module' component={PNSearchInModule} />
			<Route exact path='/post/natal/monitoring/form' component={MonitoringForm} />
			{/* lab routes */}


			<Route exact path='/labform' component={LabForm} />
			<Route exact path='/lab/blood/liver/lipid' component={BloodLiverLipid} />
			<Route exact path='/lab/malaria/pregnancy/urinalysis/stool/sediment' component={MalariaPregnacyUrinalysisStoolSediment} />
			<Route exact path='/lab/uric/thyroid/coagulation/elisa' component={UricThyroidCoagulationElisa} />
			<Route exact path='/lab/serology' component={Serology} />
			<Route exact path='/lab/tests/requested' component={TestsRequested} />


			<Route exact path='/send/to/module' component={SendToModule} />
			<Route exact path='/external/lab/tests' component={ExternalLabResults} />

			<Route exact path='/home/guest' component={GuestHome} />
			<Route exact path='/location/guest' component={Location} />
			<Route exact path='/contact/us/guest' component={ContactUs} />




		</BrowserRouter>
	);
};

export default Routes;